export default "__VITE_ASSET__BBN7017h__"